import { useSavedChartsStore } from '@/stores/savedChartsStore';
import { usePerfChartSymbols } from '@/composables/usePerfChartSymbols';
import { getChartStyle } from '@/composables/getChartStyle';
import { getSharpCharts2ChartStyle } from '@/composables/getSharpCharts2ChartStyle';
import { getStyleUrlSearchParams } from '@/utils/getStyleUrlSearchParams';
import { cloneProxyObject } from '@/utils/cloneProxyObject';

export async function getDefaultChartStyleStyleUrlSearchParams(): Promise<URLSearchParams> {
  const savedChartsStore = useSavedChartsStore();
  const { getPerfChartSymbolsString } = usePerfChartSymbols();

  const defaultChartStyle = await getChartStyle(savedChartsStore.recidOfDefaultChartStyle, true);
  const styleCacheSettingsOverridesCopy = defaultChartStyle ? cloneProxyObject(defaultChartStyle.styleCacheSettingsOverrides) : {};
  const styleCacheId = defaultChartStyle?.styleCacheId ?? 'p0';

  try {
    const chartStoreSettings = await getSharpCharts2ChartStyle(styleCacheId);

    return getStyleUrlSearchParams({
      ...chartStoreSettings,
      perfChartSymbolsString: getPerfChartSymbolsString(chartStoreSettings.perfChartSymbols),
      ...styleCacheSettingsOverridesCopy,
      i: styleCacheId
    });
  } catch (e) {
    window.sc3WorkbenchLogger.error(`Error occurred while getting default ChartStyle style URLSearchParams for styleCacheId: ${styleCacheId}.`, e);

    throw new Error(`Error occurred while getting default ChartStyle style URLSearchParams for styleCacheId: ${styleCacheId}.`, { cause: e });
  }
}
